import React, { useState } from 'react';
import { auth } from '../firebase';

const TWOFA_URL = 'https://europe-west1-dbos-core-prod.cloudfunctions.net/twofa';

export default function TwoFactorVerify({ onSuccess, onCancel }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const idToken = await auth.currentUser.getIdToken();
      const res = await fetch(TWOFA_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
        body: JSON.stringify({ action: 'verify', code }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Verification failed');
      await auth.currentUser.getIdToken(true); // refresh to pick up the claim
      onSuccess();
    } catch (err) {
      setError(err.message || 'Invalid code');
      setCode('');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo"><span className="logo-d">D</span><span className="logo-bos">BOS</span></div>
        <h1 className="login-title">Two-Factor Authentication</h1>
        <p className="login-subtitle">Enter the 6-digit code from your authenticator app.</p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleVerify} className="login-form">
          <div className="input-group">
            <label htmlFor="code">Authentication Code</label>
            <input id="code" type="text" inputMode="numeric" pattern="[0-9]{6}" maxLength="6"
              placeholder="000000" value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              required disabled={loading} autoFocus />
          </div>
          <button type="submit" disabled={loading || code.length !== 6} className="login-button">
            {loading ? 'Verifying...' : 'Verify →'}
          </button>
          <button type="button" onClick={onCancel} className="login-button"
            style={{ background: 'transparent', marginTop: '8px' }} disabled={loading}>
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
}